const Engtext={
    navigation:{
        home:"home",
        introduction:"introduction",
        report:"report",
        notice:"notice",
        covid:"covid-data",
        program:"program",
        gallery:"gallery"

    },
name:{
name:"Lalitpur Metropolitian City"
},
    OnlineRegistration:{
        onlineRegistration:"Online Registration",
        birthRegistration:"Birth Registration",
        marrageRegistration:"Marriage Registration",
        deathRegistration:"Death Registration",
        houseRegistration:"House Registration",
        migrationRegistration:"Maigration Registration"

    },
    covidUpdate:{
        heading:"CORONA UPDATES NEPAL"

    }
}
export default Engtext